import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks
 */
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [], // No HTML tags allowed
    ALLOWED_ATTR: []
  });
};

/**
 * Sanitize text input by trimming and removing potentially dangerous characters
 */
export const sanitizeText = (text: string): string => {
  if (!text) return '';
  return text.trim().replace(/[<>'"&]/g, '');
};

/**
 * Sanitize email input
 */
export const sanitizeEmail = (email: string): string => {
  if (!email) return '';
  return email.trim().toLowerCase().replace(/[<>'"&]/g, '');
};

/**
 * Sanitize filename by removing dangerous characters
 */
export const sanitizeFilename = (filename: string): string => {
  if (!filename) return '';
  return filename.replace(/[<>:"/\\|?*\x00-\x1f]/g, '').trim();
};

/**
 * Sanitize general input for API requests
 */
export const sanitizeInput = (input: any): any => {
  if (typeof input === 'string') {
    return sanitizeText(input);
  }
  if (typeof input === 'object' && input !== null) {
    const sanitized: any = {};
    for (const [key, value] of Object.entries(input)) {
      sanitized[key] = sanitizeInput(value);
    }
    return sanitized;
  }
  return input;
};